// extracted by mini-css-extract-plugin
export default {"icon":"ReviewIndicator_icon__jXuGE"};